import { requestModules } from "@r";

// export const products = [{
//   name: "潮牌羽绒服",
//   type: 1,
//   cost: 1.2,
//   skuPrefix: ["Fashion-Jacket-", "FJ-"],
//   defaultColor: "黑色",
//   defaultModel: "13ProMax",
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "透明花熊",
//   type: 2,
//   cost: 1.2,
//   defaultColor: "透明",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Flower-Bear", "EZ-M71W-VJQF"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "大耳朵花熊",
//   type: 21,
//   cost: 1.5,
//   defaultColor: "透明",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Pretty-Bear"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "钻石爱心",
//   type: 8,
//   cost: 2,
//   defaultColor: "玫瑰色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Glitter-Heart-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "白头羽绒服",
//   type: 13,
//   cost: 1.2,
//   defaultColor: "黑色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Down-Jacket"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "蝴蝶花朵",
//   type: 15,
//   cost: 1.2,
//   defaultColor: "透明",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Butterfly-Flower-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "粉色花熊",
//   type: 18,
//   cost: 1.2,
//   defaultColor: "粉色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Pink-Bear-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "褶皱锡纸",
//   type: 17,
//   cost: 1.2,
//   defaultColor: "银色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Fold-Tinfoil-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "波浪花朵熊",
//   type: 16,
//   cost: 1.2,
//   defaultColor: "透明",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Wave-Bear-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "黑绿暴力熊",
//   type: 3,
//   cost: 2,
//   defaultColor: "黑绿色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Gloomy-Bear", "G7-DIJG-SUZL"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "圆角黑绿熊",
//   type: 20,
//   cost: 2,
//   defaultColor: "黑绿色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Gloomy-Round"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "彩色油画",
//   type: 22,
//   cost: 1.5,
//   defaultColor: "绿色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Oil-Paint"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "基础磁吸",
//   type: 23,
//   cost: 1.5,
//   defaultColor: "银色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Basic-Magnetic"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "波浪闪粉",
//   type: 24,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Wave-Glitter"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "反光银镀",
//   type: 25,
//   cost: 1.5,
//   defaultColor: "薰衣草",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Reflect-Sliver"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "电镀波纹",
//   type: 26,
//   cost: 1.5,
//   defaultColor: "银色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Wavy-Ripple"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "简约斑马纹",
//   type: 27,
//   cost: 1.5,
//   defaultColor: "米黄",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Zebra-Stripe"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "基础透明",
//   type: 28,
//   cost: 1.5,
//   defaultColor: "透明",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Basic-Clear"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "基础纯色",
//   type: 29,
//   cost: 2,
//   defaultColor: "黑色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Basic-Solid-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "磁吸支架",
//   type: 30,
//   cost: 2,
//   defaultColor: "黑色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Magnet-Stand"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "玫瑰牡丹",
//   type: 31,
//   cost: 1.5,
//   defaultColor: "黑色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Peony-Rose"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "彩色油画-德夫",
//   type: 32,
//   cost: 1.5,
//   defaultColor: "绿色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Oil-Paints"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "基础透明-德夫",
//   type: 33,
//   cost: 1.5,
//   defaultColor: "透明",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Base-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "基础纯色-德夫",
//   type: 34,
//   cost: 1.5,
//   defaultColor: "透明",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Base-Solid-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "波浪爱心-德夫",
//   type: 35,
//   cost: 1.5,
//   defaultColor: "暗紫色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Plated-DoubleHeart-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "闪粉果冻软壳-德夫",
//   type: 37,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Glitter-Jelly-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "方形电镀-德夫",
//   type: 38,
//   cost: 1.5,
//   defaultColor: "白色",
//   defaultModel: "15ProMax",
//   skuPrefix: ["Square-Plate-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "纯色磨砂-德夫",
//   type: 39,
//   cost: 1.5,
//   defaultColor: "绿色",
//   defaultModel: "15ProMax",
//   skuPrefix: ["Solid-Magnetic-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "透明边框钻石-德夫",
//   type: 40,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "15ProMax",
//   skuPrefix: ["Border-Diamond-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "磁吸爱心-德夫",
//   type: 41,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "15ProMax",
//   skuPrefix: ["Magnetic-Heart-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "镭射渐变",
//   type: 42,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "15ProMax",
//   skuPrefix: ["Laser-Gradient-"],
//   shopType: 2,
//   shopName: "德夫",
//   status: 1
// }, {
//   name: "方形纯色透明",
//   type: 36,
//   cost: 1.5,
//   defaultColor: "粉色",
//   defaultModel: "14ProMax",
//   skuPrefix: ["Square-Clear-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "红色爱心",
//   type: 5,
//   cost: 1,
//   defaultColor: "勃艮第红",
//   defaultModel: "12ProMax",
//   skuPrefix: ["Red-Heart", "EA-L3FD-QLJN"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "简约波浪形",
//   type: 6,
//   cost: 1,
//   defaultColor: "透明",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Wave-Frame"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "磁吸闪粉",
//   type: 7,
//   cost: 1.5,
//   defaultColor: "金色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["MG-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 1
// }, {
//   name: "镜面爱心",
//   type: 14,
//   cost: 1.2,
//   defaultColor: "镜面",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Mirror-Heart-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "3D方块",
//   type: 19,
//   cost: 1.2,
//   defaultColor: "黑色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Laid-Desgin-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "彩色镂空",
//   type: 4,
//   cost: 1,
//   defaultColor: "蓝色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["CH-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "连环爱心",
//   type: 9,
//   cost: 1,
//   defaultColor: "蓝色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Heart-Print-"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "暴力熊",
//   type: 10,
//   cost: 2,
//   defaultColor: "银色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["1M-PSR3-XX63"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "保持微笑",
//   type: 11,
//   cost: 1.5,
//   defaultColor: "彩色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["7D-R2GV-PUYW"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }, {
//   name: "推窗",
//   type: 12,
//   cost: 1.5,
//   defaultColor: "红色",
//   defaultModel: "13ProMax",
//   skuPrefix: ["Push-Window-Pink"],
//   shopType: 1,
//   shopName: "灵柚",
//   status: 0
// }];

// export const activeProducts = products.filter(product=>product.status == 1)

// export const colors = [{
//   key: "Black",
//   name: "黑色"
// }, {
//   key: "White",
//   name: "白色"
// }, {
//   key: "Clear",
//   name: "透明"
// }, {
//   key: "Blue",
//   name: "蓝色"
// }, {
//   key: "Brown",
//   name: "棕色"
// }, {
//   key: "Pink",
//   name: "粉色"
// }, {
//   key: "Purple",
//   name: "紫色"
// }, {
//   key: "Green",
//   name: "绿色"
// }, {
//   key: "Gold",
//   name: "金色"
// }, {
//   key: "Silver",
//   name: "银色"
// }, {
//   key: "Rose",
//   name: "玫瑰色"
// }, {
//   key: "Burgundy",
//   name: "勃艮第红"
// }, {
//   key: "Red",
//   name: "红色"
// }, {
//   key: "Light-Green",
//   name: "浅绿色"
// }, {
//   key: "Light-Blue",
//   name: "浅蓝色"
// }, {
//   key: "Dark-Blue",
//   name: "深蓝色"
// }, {
//   key: "Yellow",
//   name: "黄色"
// }, {
//   key: "Gray",
//   name: "灰色"
// }, {
//   key: "Beige",
//   name: "米黄"
// }, {
//   key: "Lavender",
//   name: "薰衣草"
// }, {
//   key: "Cherry-Pink",
//   name: "樱桃粉"
// }, {
//   key: "Cobalt-Blue",
//   name: "钴蓝"
// }, {
//   key: "Color-Pink",
//   name: "彩粉"
// }, {
//   key: "Color-Green",
//   name: "彩绿"
// }, {
//   key: "Rose-Yellow",
//   name: "玫瑰黄"
// }, {
//   key: "Rose-Pink",
//   name: "玫瑰粉"
// }, {
//   key: "Laser",
//   name: "镭射"
// }];

// export const models = ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"];

// export const GloomyRoundBear = {
//   baseSku: "Gloomy-Round-",
//   // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
//   models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11"],
//   colors: [""],
//   title: "IAIYOXI Phone Case Compatible with iPhone _model_ Cool Army Green 3D Bear Pattern,Fashion Round Corners Desigin,Slim TPU Case, Shockproof,Full Body Protection Case/Cover/Skin for Boy Men",
//   desList: [
//     "❤【Compatible model】 The phone case Only Compatible with iphone _model_",
//     "❤【Cool 3D Bear】 Fashion Funny Kawaii cartoon graffiti skin phone case cover with Armygreen camo 3D bear pattern character,very stylish and unique,let you look different.Street trend and fashion lovers must have item",
//     "❤【DESIGN】 Fashion Round Corners design with flexible plastic material and IMD technology - easily install and remove, without damaging or scratching the phone body. Phone case is thin and lightweight for flexible durability.",
//     "❤【COLOR & FINISH】 Semi-gloss finish with unparalleled graphic printing technology, Vivid bright print technology that will not fade.",
//     "❤【Full Body Protection】 Raised edges for extra protection of screen and camera - slim fit with sleek design. This stunning case makes the perfect fashion-forward gift for your loved ones."
//   ]
// }

export const FlowerBear = {
  baseSku: "Flower-Bear-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["", "Black", "Green", "Purple", "Blue"],
  title: "IAIYOXI Case for iPhone _model_ with Cute Flowers Bear Pattern, Camera Protector, Clear Case and Lovely Strap Bracelet Chain for Girls Women, Compatible for iPhone _model_ , _color_",
  desList: [
    "❤【Compatibility】 This phone case is designed specifically for iPhone _model_ and is compatible with wireless charging, making it a great choice for busy women on the go.",
    "❤【Stylish Design】 The cute and feminine flower and bear pattern on this phone case will make your iPhone stand out while showing off your unique style.",
    "❤【Durable and Flexible】 Made from high-quality, soft rubber material, this phone case provides exceptional protection against scratches, drops, and dirt. Its flexible design makes it easy to install and remove.",
    "❤【Vivid Printing】 The printing on this phone case is made using advanced technology and high-quality materials, ensuring that it's both vivid and long-lasting, so you can enjoy the beautiful pattern for years to come.",
    "❤【Convenient and Secure】 This phone case comes with a handy bracelet chain, making it easy for you to carry your iPhone with you at all times. The chain ensures that your phone is always within reach and secure, making it perfect for women who are always on the move.",
  ],
};

export const PrettyFlower = {
  baseSku: "Pretty-Bear-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Clear-White"],
  title: "IAIYOXI Case for iPhone _model_ with Cute Flowers Bear Pattern, Camera Protector, Clear Case and Lovely Strap Bracelet Chain for Girls Women, Compatible for iPhone _model_, _color_",
  desList: [
    "❤【Compatibility】 This phone case is designed specifically for iPhone _model_ and is compatible with wireless charging, making it a great choice for busy women on the go.",
    "❤【Stylish Design】 The cute and feminine flower and bear pattern on this phone case will make your iPhone stand out while showing off your unique style.",
    "❤【Durable and Flexible】 Made from high-quality, soft rubber material, this phone case provides exceptional protection against scratches, drops, and dirt. Its flexible design makes it easy to install and remove.",
    "❤【Vivid Printing】 The printing on this phone case is made using advanced technology and high-quality materials, ensuring that it's both vivid and long-lasting, so you can enjoy the beautiful pattern for years to come.",
    "❤【Convenient and Secure】 This phone case comes with a handy bracelet chain, making it easy for you to carry your iPhone with you at all times. The chain ensures that your phone is always within reach and secure, making it perfect for women who are always on the move.",
  ],
};

export const FashionJacket = {
  baseSku: "Fashion-Jacket-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Black", "White", "Green", "Brown", "Blue", "Red"],
  title: "IAIYOXI Puffer Case with Sports Shoes Brand Design for iPhone _model_,Sneakers Ins White or Black Label Soft Cover-_color_ Puffy Cover for iPhone Model 15 14 13 12 11 Pro Max Plus X XS XR 7 8 (_color_)",
  desList: [
    "✔【Compatibility】 This phone case is designed specifically for iPhone _model_, making it a great choice for busy boy man on the go.",
    "✔【Trendy Puffer Design】 Inspired by the popular down jacket style, this puffer case is a stylish choice that will elevate your fashion game all year round. The unique white/black label sneakers design adds an extra touch of cool.",
    "❤【Soft Touch & Comfortable Grip】 Made with high-quality TPU bumper and soft down jacket material, this case provides a comfortable and soft grip, while also protecting your phone's corners from scratches and drops.",
    "✔【Lightweight & Portable】 Our puffer case is puffy but not bulky, making it easy to carry in your pocket or purse. It is super cute and protective, and you can easily wipe it clean if it gets dirty.",
    "✔【Shockproof & Anti-scratch Protection】 With shockproof soft back padding and raised edges, our case offers reliable protection for your phone's screen and camera from accidental drops, bumps, or scratches. Keep your phone safe and stylish at the same time.",
  ],
};

export const DownJacket = {
  baseSku: "Down-Jacket-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Black", "White", "Green", "Brown", "Blue", "Red"],
  title: "IAIYOXI Puffer Case with Sports Shoes Brand Design for iPhone _model_,Sneakers Ins White or Black Label Soft Cover-Black Puffy Cover for iPhone Model 15 14 13 12 11 Pro Max Plus X XS XR 7 8 (_color_)",
  desList: [
    "✔【Compatibility】 This phone case is designed specifically for iPhone _model_, making it a great choice for busy boy man on the go.",
    "✔【Popular Puffy Design】The puffer case is an very trendy case for iphone. Design inspired by down jacket. Holding a puffer case with this unique design will make you more fashionable in all seasons.",
    "❤【Puffy Soft Touch】This phone case is made of soft and high-quality TPU bumper + back down jacket material, a soft hand and a comfortable grip. The corners protection, helps prevent scratches and drops.",
    "✔【Light Design】It is puffy but not bulky so it fits in a pocket.super cute and protective! you do not need to worry about it being bulky, it’s just a little puffy ridged and you can wipe it clean if it gets dirty.",
    "✔【Shockproof & Anti-scratch Protection】 With shockproof soft back padding and raised edges, our case offers reliable protection for your phone's screen and camera from accidental drops, bumps, or scratches. Keep your phone safe and stylish at the same time.",
  ],
};

export const PinkBear = {
  baseSku: "Pink-Bear-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Pink", "Yellow", "Brown"],
  title: "IAIYOXI 3D Cute Cartoon Bear Phone Case for iPhone _model_ - Fashionable and Stylish - Funny Pink Bear Design - Soft TPU Protective Case - Kawaii Silicone Cover for Women, Girls, and Kids (_color_)",
  desList: [
    "【Compatibility】 This adorable Kawaii bear phone case is specifically designed for iPhone _model_. Please note that it is not compatible with any other phone models, so make sure to check your phone model before making a purchase.",
    "【Cute Cartoon Bear Design】 Featuring a super creative 3D cartoon bear design, this phone case adds a touch of creativity, novelty, and fashion to your iPhone _model_. It's a fun and interesting way to personalize your device.",
    "【Shock & Drop Protection】 Made of high-quality soft silicone with a medium hardness, the pink bear phone case offers excellent grip and prevents your iPhone from slipping out of your hand. It provides effective cushioning and protection in case of accidental drops, keeping your phone safe and secure.",
    "【Convenient】 The cute bear phone case for iPhone _model_ is designed to be convenient for everyday use. You can charge your phone without removing the case, and it is also sweat-proof and fingerprint-proof, ensuring a clean and comfortable user experience.",
    "【Perfect Gift Choice】 This super cool 3D cartoon bear phone case makes for an ideal gift choice. Whether it's for a birthday or Mother's Day, it's a great present for girls and women, including your mother, girlfriend, daughter, and more. Surprise them with this unique and stylish accessory for their iPhone _model_.",
  ],
};

export const FoldTinfoil = {
  baseSku: "Fold-Tinfoil-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Silver"],
  title: "IAIYOXI Compatible for iPhone _model_ Glitter Case, Cute Fashion Bling Glitter Silver Tin Foil 3D Pleats Design for Women Girls with Soft Silicone, Shockproof Soft Case Cover for iPhone _model_",
  desList: [
    "❤【Compatibility】 Specially designed only for iPhone _model_, fits perfectly, smooth and cute, Support Wireless Charging.",
    "❤【3D Tin Foil Design】 The Fashion 3D Tin Foil bling pleats design design for Women Teen Girls. Durable and flexible silicone material. makes your phone so pretty.",
    "❤【High-quality Materials】 This phone case is made of High-quality TPU material, not easily fade in color or shape change over time.",
    "❤【Full Body Protection】 This case provide good support cushion for shockproof, smooth TPU exterior cover protects your phone from scratches and drop.",
    "❤【Bright and Eye-catching】 Cute bling pleats With a bright and eye-catching appearance, makes your iPhone different, make you become the focus of the crowd and show your personality.",
  ],
};

export const OilPaint = {
  baseSku: "Oil-Paint-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Green"],
  title: "IAIYOXI Case for iPhone _model_ - Vivid Retro Oil Painting, Flower Laser Glossy Pattern, Cute Curly Wave Edge - Exquisite Stylish Durable TPU Protective Phone Cover for Girls and Women (_color_)",
  desList: [
    "❤【Compatible Model】 This exquisite oil painting flower design phone case is specifically designed for the iPhone _model_ ONLY. Please double-check the phone model size carefully before making your purchase.",
    "❤【Fashionable Glitter Print Flower】 The captivating shimmer of this sparkling, diamond-like, pearly-lustre oil painting floral design is a fashion statement, showcasing your unique personality. The graphic printing design ensures that the shiny gradient pearl-like shine remains vibrant over time. Expect to receive many compliments with this eye-catching case.",
    "❤【Premium Material】 Crafted from high-quality ultra-thin soft TPU, this case provides 360° protection against scratches and falls. The smooth wave line frame enhances the grip, ensuring a comfortable feel in your palm. It's easy to install and remove, combining both style and functionality.",
    "❤【Excellent Protection】 The raised-up lips around the camera enhance protection against accidental scratches, falls, and bumps. The slightly raised edge of the phone case also provides added safeguarding for the screen, while the light and soft flexible TPU material maintain a slim and comfortable profile without bulk.",
    "❤【Slim & Precise Cutouts】 The snug fit and precise cutouts grant easy access to ports, buttons, microphone, camera, and speaker. This case is designed to support wireless charging, combining slim aesthetics with practical functionality.",
  ],
};

//德夫
export const OilPaints = {
  baseSku: "Oil-Paints-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Purple"],
  title: "IAIYOXI Case for iPhone _model_, Vivid Retro Flower Laser Glossy Pattern Oil Painting, Exquisite Stylish Durable TPU Protective，Cute Curly Wave Edge Phone Cover for Girls and Women (_color_)",
  desList: [
    "【Compatible Model】 This exquisite oil painting flower design phone case is tailored exclusively for the iPhone _model_. Please ensure to verify your phone model size before making a purchase.",
    "【Fashionable Glitter Print Flower】 Experience the captivating shimmer of this sparkling, diamond-like, pearly-lustre oil painting floral design. It's a fashion statement that showcases your unique personality. The graphic printing design ensures the shiny gradient pearl-like shine remains vibrant over time, earning you many compliments with its eye-catching appeal.",
    "【Premium Material】 The smooth wave line frame enhances grip, ensuring a comfortable feel in your palm. It's easy to install and remove, seamlessly combining style with functionality.Crafted from high-quality ultra-thin soft TPU, this case offers 360° protection against scratches and falls.",
    "【Excellent Protection】 The raised-up lips around the camera enhance protection against accidental scratches, falls, and bumps. The slightly raised edge of the phone case also provides added safeguarding for the screen. Meanwhile, the light and soft flexible TPU material maintain a slim and comfortable profile without bulk.",
    "【Slim & Precise Cutouts】 Enjoy a snug fit and precise cutouts that grant easy access to ports, buttons, microphone, camera, and speaker. This case is designed to support wireless charging, offering slim aesthetics with practical functionality.",
  ],
};

export const BasicMagnetic = {
  baseSku: "Basic-Magnetic-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max"],
  colors: ["Sliver", "Black", "Blue", "Purple", "Gold"],
  // colors: ["Sliver"],
  title: "IAIYOXI Plating Case for iPhone _model_ with Camera Lens Protector,Anti-Scratch Shockproof Slim Protective Case, Ideal for Women and Men，Compatible for iPhone _model_, _color_",
  desList: [
    "❤【Compatibility】Exclusively designed for iPhone _model_, ensuring a perfect fit. It seamlessly supports wireless charging, making it a convenient choice for your charging needs.",
    "❤【Wireless Charger】With its built-in strong magnet design, Crafted from soft TPU material,Its easy-to-clean, this case is compatible with any wireless charging device.",
    "❤【Slim and Pocket-Friendly】The slim profile of this case makes it pocket-friendly, allowing for easy insertion and removal. Enjoy the benefits of a protective case without compromising on portability.",
    "❤【Effective Protection】The slim design doesn't compromise on protection. The raised edges around the screen and camera lens provide added protection, safeguarding your device against scratches and potential impacts.",
    "❤【Precise Cutouts】The case features precise cutouts, allowing easy access to all controls and features. Perfectly aligned cutouts for speakers, camera, and other ports ensure a seamless user experience.",
  ],
};

export const WaveGlitter = {
  baseSku: "Wave-Glitter-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  // models: ["14 Pro Max"],
  colors: ["Pink", "Purple", "Blue", "Black", "Clear"],
  title: "IAIYOXI for iPhone _model_ - Curly Wave Edge Design, Transparent Bling Glitter Star Shiny Case, Cute Pink Clear Full Protection Soft TPU Shockproof Phone Cover for Women and Girls (_color_)",
  desList: [
    "❤【Compatibility】Specifically designed for the iPhone _model_, this Bling Glitter Star Phone Case adds a touch of glamour to your device.",
    "❤【Protection】The case features raised camera lips and front lips, providing comprehensive protection for your phone's lens and screen. This ensures professional-grade protection against potential scratches and impacts.",
    "❤【High-quality Materials】Crafted from transparent TPU material, the case is anti-fingerprint, anti-scratch, dirt-resistant, and drop-resistant. This material allows the beauty of your iPhone's design to shine through while providing reliable protection.",
    "❤【Wavy Border Frame】The wavy border frame not only enhances the aesthetic appeal but also serves a functional purpose. It provides an ergonomic grip, making it easier to hold the phone securely and helping to prevent accidental drops.",
    "❤【Access to All Controls and Features】Enjoy full functionality with easy access to all controls and features. The case boasts perfect cutouts for speakers, camera, and other ports, ensuring a seamless user experience.",
  ],
};

export const ReflectSliver = {
  baseSku: "Reflect-Sliver-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max"],
  // models: ["14 Pro Max"],
  colors: ["Lavender", "Black", "White", "Purple", "Pink"],
  title: "IAIYOXI for iPhone _model_ Case - Cute Love Heart Luxury Plating, Soft Bling Back Cover, Raised Full Camera Protection, Bumper Silicone Shockproof Phone Case for Women Girls (_color_)",
  desList: [
    "❤【Compatibility】Specifically crafted for the iPhone _model_, It fully supports wireless charging for your convenience.",
    "❤【Raised Bezel Camera Design】Experience a perfect blend of elegance and functionality with the raised lip design dedicated to protecting your camera lens. This thoughtful design provides an additional layer of defense without obstructing the use of your wide-angle camera and flashlight.",
    "❤【High-quality Materials】Crafted from TPU material, this case is a harmonious balance of softness, smoothness, durability, and easy cleaning. The premium quality TPU not only ensures a comfortable and sleek touch but also offers excellent drop protection and scratch resistance.",
    "❤【Luxury and Stylish】Elevate your iPhone's aesthetics with the luxurious touch of electroplating technology. The beautiful gold plating gracefully envelops the bumper edges and camera, showcasing your love for luxury and fashion. This case is designed to make a statement and exude confidence.",
    "❤【Epic Precision】The TeaGeo case perfectly aligns with every contour of your iPhone. Its silicone form snugly fits over the volume buttons, Sleep/Wake button, and curves of your device. The tactile button covers provide a responsive touch, ensuring easy access to all functions.",
  ],
};

export const ZebraStripe = {
  baseSku: "Zebra-Stripe-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  colors: ["Beige", "Green", "Blue", "Gray"],
  title: "IAIYOXI Case for iPhone _model_ - Soft PU Leather TPU, Cute Art Wavy Painted Design for Women Girls, Slim Protective Shockproof Cover, Compatible with iPhone _model_ (_color_)",
  desList: [
    "❤【Multiple Variants】Specifically designed for the iPhone _model_",
    "❤【Fashion 3D Striped】Elevate your phone's style with this cute art wave-painted phone case featuring a fun and scratch-resistant black beige wave pattern. The design adds a touch of flair, giving your device a stylish and attractive look.",
    "❤【High-Quality Material】Crafted from soft PU leather TPU material, this case is soft, shockproof, smooth, durable, and easy to clean. The lightweight and slim design ensure that it's not bulky, making it easy to carry around.",
    "❤【Scratch Resistant】Equipped with 1.6mm screen bezels and 2.5mm camera bezels, this case provides comprehensive protection by preventing daily scratches. The raised lips ensure full-body protection for your device.",
    "❤【Good Choice For Gift】Make a statement with this stylish case—it's a wonderful gift choice for your loved ones. Rest assured, any purchases with us are backed by quality assurance and 24/7 customer service.",
  ],
};

export const WavyRipple = {
  baseSku: "Wavy-Ripple-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max"],
  // models: ["14 Pro Max"],
  colors: ["Sliver", "Black", "White", "Pink", "Green"],
  title: "IAIYOXI iPhone _model_ Case - Wavy Edge Water Ripple Pattern Design, Cute Wave Curly Frame Shape, Soft Flexible TPU Shockproof Full-Body Protective Cover for Women Girls - Shiny _color_",
  desList: [
    "❤【Perfect Compatibility】Tailored for the iPhone _model_, this case supports wireless charging without the need for removal. It's effortlessly easy to put on and take off.",
    "❤【Stylish & Cute Case】Featuring a wavy edge water ripple pattern, this case is both cute and fashionable, enhancing the look of your phone and making it eye-catching. It also serves as a delightful gift for your family and friends.",
    "❤【Screen & Full Camera Protection】The raised-up edges are designed to provide maximum protection for your screen from daily wear and scratches. The case is equipped with an upgraded full camera lens protection design, guarding against impacts from accidental drops and preventing dust infiltration.",
    "❤【Soft & Protective】Crafted from high-quality upgraded TPU materials, this case is lightweight, soft to touch, and offers durable protection. The curved edges provide an easier grip, ensuring it's not slippery and comfortable to hold in your hand.",
    "❤【Precise Cutouts】Enjoy exact cutouts for all ports and buttons, providing easy access to all original functions with full cover protection. Additionally, the case is easy to clean, ensuring it remains in pristine condition.",
  ],
};

export const BasicClear = {
  baseSku: "Basic-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  //   models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Clear"],
  title: "IAIYOXI Clear Case for iPhone _model_ - Crystal Clear Military Grade Drop Protection, Non-Yellowing Armor, Shockproof Protective Cover, Compatible with iPhone _model_ (iPhone _model_)",
  desList: [
    "❤【Compatible with】Specifically designed for iPhone _model_, this case offers easy access to all buttons, controls, and ports. Each button has independent plating for durability and ease of use. It supports wireless charging for added convenience.",
    "❤【Material】 Crafted from crystal clear and non-yellowing materials sourced from Germany, this case maintains long-lasting clarity. The high-grade ultra-clear TPU frame and PC back cover material ensure that the case remains clear and does not turn yellow over time. It is resistant to oils, ultraviolet light, and yellowing, providing enduring clarity.",
    "❤【Military-grade Protection】 Engineered with Shock-pocket in the 4 corners Technology, this case disperses severe shocks effectively. The combination of rigid polycarbonate backplane and flexible shockproof TPU bumpers around the edge creates tough protection against impacts and drops.",
    "❤【Raised Camera & Screen Protection】 With raised bezels, this case offers comprehensive protection for the screen and camera against drops and scratches. The 1.5mm bezels over the screen and 1.5mm+camera 2.0mm raised corner lips on the back provide additional protection for peace of mind.",
    "❤【Excellent Grip & Portability】 Despite its protective features, this case maintains minimal bulkiness, ensuring easy portability and perfect fit in pockets. It is designed for one-handed operation, with a processed TPU frame that provides a delicate touch feeling and non-slip grip for added convenience.",
  ],
};

export const BasicSolid = {
  baseSku: "Basic-Solid-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["14 Pro Max"],
  colors: ["Black", "White", "Cherry-Pink", "Cobalt-Blue", "Green", "Lavender"],
  title: "",
  desList: [
    "❤【 Durable Liquid Silicone Case】 Designed for iPhone _model_, this liquid silicone case comes in multiple color choices and supports wireless charging.",
    "❤【 Full Body Protection】 Featuring 1.2 mm raised lips, this case protects your screen and camera from scratches and drops.The soft microfiber lining inside prevents scratching, ensuring comprehensive protection for your phone.",
    "❤【 Excellent Grip and Non - slip】 Crafted from premium liquid silicone material, this case offers a sleek yet non - slip grip.It 's easy to clean with a simple wipe, providing both functionality and style.",
    "❤【 Slim & Perfect Fits】 With precise cutouts, you can easily access all ports without interference with microphone usage.Slim and protective, this case adds no extra bulk to your phone, ensuring a perfect fit.",
    "❤【 Lifetime Replacement】 We stand behind our product with a lifetime replacement guarantee for your iPhone 14 Pro Max silicone case.Your satisfaction is our priority.",
  ],
};

export const PeonyRose = {
  baseSku: "Peony-Rose-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  //   models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Black"],
  title: "IAIYOXI Case for iPhone _model_ - Black Flower Floral Pattern Design, Soft TPU Bumper, Hard PC Back, Anti-Fall Shockproof Protective Slim Magnetic Cover for Women Girls",
  desList: [
    "❤【Compatible with】This phone case is exclusively designed for the iPhone _model_, ensuring a perfect fit.",
    "❤【Wireless Charger】It supports wireless charging and effortlessly attaches your phone directly to a magnetic car bracket.",
    "❤【Effective Protection】Crafted from PC and TPU materials, it effectively reduces the impact of falls and prevents scratches. The excellent camera settings offer additional protection for your phone's camera from scratches.",
    "❤【Fashion design】The flower design adds a touch of fashion to your iPhone _model_, while the perfect printing technology ensures that the pattern remains vibrant without fading.",
    "❤【24h Service】If you have any questions about the phone case, please don't hesitate to contact us. We're here to assist you.",
  ],
};

export const MagnetStand = {
  baseSku: "Magnet-Stand-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  //   models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Black", "Purple", "Gold", "Blue", "Pink"],
  title: "IAIYOXI iPhone _model_ Case with Magnetic Ring Stand - Four Corners Shockproof [Military Grade Drop Protection], Luxury Slim Kickstand Case for iPhone _model_ - _color_",
  desList: [
    "❤【Compatibility】Specifically designed for iPhone _model_, please ensure your phone model matches before purchasing.",
    "❤【Powerful Magnetic】This four-corner airbag magnetic invisible stand phone case supports wireless charging. The metal iron ring design allows for easy attachment to magnets, ensuring quick and secure locking while driving or wirelessly charging. Experience stable phone placement without worrying about shaking or accessories falling off. Enjoy fast charging whether you're at work or traveling.",
    "❤【Invisible Kickstand Design】Featuring an innovative invisible stand design, this case enhances the aesthetics of your phone while providing convenient functionality. The circular bracket, made of lightweight and durable aviation aluminum alloy, elevates the protection of the phone case. It can be stably placed in portrait or landscape mode and adjusted between 40° and 120° as needed.",
    "❤【Military Grade Protection】With this four-corner airbag magnetic invisible stand phone case, your phone is certified to withstand over 5000 falls from a height of 5Ft onto hard ground. The PC hard back panel and TPU bumper effectively disperse vibration from accidental impacts. Upgraded air cushioning and bumper reinforcement ensure high durability, minimizing phone damage from drops.",
    "❤【Effective Protection】The edge design above the screen and camera provides enhanced protection against falls, safeguarding your phone from damage. A transparent protective film is factory-installed to cover the inside of the phone case and the transparent area in the middle of the metal ring, preventing scratches and cracks during packaging.",
  ],
};

export const BaseClear = {
  baseSku: "Base-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  //   models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Clear"],
  title: "IAIYOXI Clear Case for iPhone _model_ - MagSafe Compatible, Non-Yellowing Shockproof Bumper Cover, Anti-Scratch (iPhone _model_)",
  desList: [
    "❤【Compatible with】Customized for iPhone _model_. Perfectly fits your iPhone _model_. Supports wireless charging. ",
    "❤【Material】Made with PC and TPU. Inner tiny dots design avoids ugly watermark against the phone back and sides. Lightweight and slim design. Ultra transparent and scratch-resistant back",
    "❤【Military-grade Protection】 Raised bezels offer extra protection for screen and camera. Unique shock-absorption design: 4 corners effectively absorb shocks",
    "❤【Easy Access Controls】 Easy access to all the controls and features. Perfect cutouts for speakers, camera and other ports",
    "❤【Good Choice For Gift】Make a statement with this stylish case—it's a wonderful gift choice for your loved ones. Rest assured, any purchases with us are backed by quality assurance and 24/7 customer service.",
  ],
};

export const BaseSolid = {
  baseSku: "Base-Solid-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15 Pro Max"],
  colors: ["Black", "White", "Pink", "Dark-Blue", "Dark-Green", "Red"],
  title: "IAIYOXI Case for iPhone _model_ - Silicone Shockproof Cover with Soft Anti-Scratch Microfiber Lining, _color_",
  desList: [
    "❤【Durable Liquid Silicone Case】Tailored for iPhone _model_, this case offers multiple color choices and supports wireless charging.",
    "❤【Full Body Protection】Featuring 1.2mm raised lips, it safeguards your screen and camera from scratches and drops. The soft microfiber lining inside prevents scratching, ensuring comprehensive protection for your phone.",
    "❤【Excellent Grip and Non-slip】Crafted from premium liquid silicone material, it offers a sleek yet non-slip grip. Easy to clean with a wipe, this material ensures a comfortable and secure hold.",
    "❤【Slim & Perfect Fits】With precise cutouts, it grants easy access to all ports without interfering with microphone usage. Slim yet protective, it adds no extra bulk to your phone.",
    "❤【Lifetime Replacement】We stand behind our product with a lifetime replacement guarantee for your iPhone _model_ silicone case. Your satisfaction is our priority.",
  ],
};

// 纯色磨砂
export const SolidMagnetic = {
  baseSku: "Solid-Magnetic-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15 Pro Max"],
  colors: ["Green", "Blue", "Black", "Purple", "Gold"],
  title: "IAIYOXI Magnetic Case for iPhone _model_ Phone Case for Women - Matte Luxury Soft Metallic Luster Design with Camera Lens Protector, Compatible with MagSafe for iPhone _model_ - _color_",
  desList: [
    "❤【Compatible Models】Exclusively compatible with the iPhone _model_. Not suitable for any other device.",
    "❤【Strong Magnet】Equipped with a built-in N52 strong magnet design, this case is compatible with any wireless charging device. Enhancing the MagSafe connection, it facilitates faster and easier charging, shortening overall charging time and enhancing your wireless charging experience.",
    "❤【Camera Protection】Featuring an all-inclusive lens piece, this case provides superior protection for your iPhone _model_'s camera lens, ensuring its safety from scratches and impacts.",
    "❤【High Quality Material】Crafted from luxury matte soft metallic gloss material, this case offers a sleek and premium feel. Shockproof, smooth, durable, and easy to clean, it provides a comfortable touch. The slim design makes it pocket-friendly and easy to insert or remove from pockets.",
    "❤【Better Protection】The raised edges around the screen and camera lens offer enhanced protection against scratches and impacts, safeguarding your phone's display and camera lens.",
  ],
};

// 透明边框钻石
export const BorderDiamond = {
  baseSku: "Border-Diamond-",
  // models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  models: ["15 Pro Max"],
  colors: ["Pink", "Clear", "Gray", "Purple"],
  title: "IAIYOXI Designed for iPhone _model_ Phone Case - Sparkly Cute Clear Case for Women Girls, Glitter Bling Flexible Soft TPU Silicone Bumper Protective Cover,Compatible with iPhone _model_ - _color_",
  desList: [
    "❤【Compatibility】 Tailored for the iPhone _model_, ensuring a perfect fit for your device.",
    "❤【Star Diamond Design】 Featuring a cute clear design adorned with star diamonds, this iPhone _model_ case stands out with its unique beauty. The combination of beautiful neon colors and sparkling glitters adds a touch of luxury to your phone.",
    "❤【Premium Material】 Crafted from high-quality eco-friendly liquid silicone, this case is resistant to yellowing, dust, and fingerprints, keeping your phone clean and pristine at all times.",
    "❤【All-round Protection】 Enjoy 360° all-round drop protection with the internal TPU bumper, which effectively resists shocks and scratches. The raised design around the camera and screen provides additional protection against drops, scratches, and other impacts.",
    "❤【PERFECT FIT】 With precise cutouts for all buttons and ports, this case offers easy access to all controls and functions, including speakers, camera, and other ports. Enjoy a perfect fit that complements the functionality of your iPhone _model_.",
  ],
};

export const BaseProduct = {
  baseSku: "Fold-Tinfoil-",
  models: ["15", "15 Pro", "15 Plus", "15 Pro Max", "14", "14 Pro", "14 Plus", "14 Pro Max", "13", "13 Pro", "13 Pro Max", "13 Mini", "12", "12 Pro", "12 Pro Max", "11", "11 Pro", "11 Pro Max", "X", "XR", "Xs Max", "7", "8", "SE 2020", "SE 2022", "7 Plus", "8 Plus"],
  //   models: ["15", "15 Pro", "15 Plus", "15 Pro Max"],
  colors: ["Sliver"],
  title: "",
  desList: ["", "", "", "", ""],
};

export const products = [];
export const activeProducts = [];
export const colors = [];
export const models = [];
export const iPhoneModels = [];
export const allActiveProducts = [];

function getAllProducts() {
  requestModules.fetchParentProducts({}).then(res => {
    let allProducts = res.ldata;
    allProducts.forEach(pd => {
      products.push(pd);
      pd.status == 1 && activeProducts.push(pd);
    });
  });
}

function getAllParentProducts() {
  requestModules.fetchAllParentProducts({}).then(res => {
    let allProducts = res.ldata;
    allProducts.forEach(pd => {
      pd.status == 1 && allActiveProducts.push(pd);
    });
  });
}

export function getPhoneCaseContantInfo() {
  requestModules.fetchPhoneCaseContantInfo({}).then(res => {
    let colorsList = res.mdata.colors;
    let modelsList = res.mdata.models;
    let iPhoneModelsList = res.mdata.iPhoneModels;
    let sumsungModelsList = res.mdata.sumsungModels;
    let modelsForSumsungList = res.mdata.modelsForSumsung;

    colors.length = 0;
    models.length = 0;
    iPhoneModels.length = 0;

    colorsList.forEach(color => {
      colors.push(color);
    });
    modelsList.forEach(model => {
      models.push(model);
    });
    // modelsForSumsungList.forEach(model => {
    //   models.push(model);
    // });
    iPhoneModelsList.forEach(model => {
      iPhoneModels.push(model);
    });
    // sumsungModelsList.forEach(model => {
    //   iPhoneModels.push(model);
    // });
    getAllProducts();
    getAllParentProducts();
  });
}
getPhoneCaseContantInfo();
